import { type ReactNode } from "react";

import { tw } from "~/utils";
import { DropdownInput, DropdownOption } from "../components";

type TitleProps = {
  title: string;
  options?: DropdownOption[];
  selected?: DropdownOption;
  onChange?: (option: DropdownOption) => void;
  label?: (option: DropdownOption) => string;
  className?: string;
  titleClassName?: string;
  action?: ReactNode;
};

export const Title = ({
  title,
  options,
  selected,
  onChange,
  label = (option) => `Showing ${option.label}`,
  className,
  titleClassName,
  action,
}: TitleProps) => {
  return (
    <div
      className={tw("flex w-full items-center justify-between py-8", className)}
    >
      <div className="flex items-center gap-4">
        <h2
          className={tw(
            "font-ivy text-2xl text-neutral-600",
            !options && "flex min-h-10 items-center",
            titleClassName,
          )}
        >
          {title}
        </h2>

        {action}
      </div>

      {options && selected && onChange && (
        <DropdownInput
          options={options}
          label={label}
          selected={selected}
          handleOnChange={onChange}
        />
      )}
    </div>
  );
};
